module.exports = "https://cdn.dove.it/_next/static/public/assets/adv/fixed-side-banner-guide.01344afee6545630ab15d400e91a91c1.jpg";